import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatSidenavModule} from '@angular/material/sidenav';
import {SharedModule} from 'src/app/shared/shared.module';
import {LayoutComponent} from './layout.component';
import {RouterModule} from '@angular/router';
import {LayoutRoutingModule} from 'src/app/layout/layout-routing.module';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {FooterModule} from './footer/footer.module';
import {LeftSideNavigationModule} from './left-side-navigation/left-side-navigation.module';
import { IconsModule } from '../icons/icons.module';

@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    LayoutRoutingModule,

    CommonModule,
    SharedModule,

    ToolbarModule,
    LeftSideNavigationModule,
    FooterModule,

    RouterModule,
    MatSidenavModule,
    IconsModule

  ]
})
export class LayoutModule {
}
